<template>
  <div class="assets" @scroll="handleScroll">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang205') }}</span>
    </div>

    <div class="pd">
      <div class="">
        <!-- <div class="total_box">
          <div>
            <span class="text">{{ $t('lang112') }}</span>
          </div>
          <div class="f-sa">
            <div class="item">
              <span class="total">{{ Math.floor(assets * 100) / 100 || 0 }}</span>
              <span>USDT</span>
            </div>
            <div class="item">
              <span class="total">{{ Math.floor(totalReward * 100) / 100 || 0 }}</span>
              <span>{{ $t('lang174') }}</span>
            </div>
          </div>
          <div class="buy buy1" @click="navigation('recharge')">
            <van-button class="buy_btn" type="primary">
              <van-icon name="pending-payment" size="18" />
              {{ $t('lang138') }}
            </van-button>
          </div>
          <div class="buy" @click="navigation('withdraw')">
            <van-button class="buy_btn" type="primary">
              <van-icon name="paid" size="18" />
              {{ $t('lang113') }}
            </van-button>
          </div>
        </div> -->
        <div class="bg">
          <div class="total_box" v-if="coin_type == 'token'">
            <div>
              <span class="text f">
                {{ $t('lang80') }}(
                <svg width="12" height="22" viewBox="30 0 50 96" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                    fill="none"
                    stroke="rgba(255, 255, 255, 0.8)"
                    stroke-width="6"
                    stroke-linecap="round"
                  />
                  <line x1="52" y1="29" x2="52" y2="73" stroke="rgba(255, 255, 255, 0.8)" stroke-width="5.2" stroke-linecap="round" />
                  <line x1="63" y1="29" x2="63" y2="73" stroke="rgba(255, 255, 255, 0.8)" stroke-width="5.2" stroke-linecap="round" />
                </svg>
                )
              </span>
            </div>
            <div class="total">
              <span>{{ Math.floor(balance * 100) / 100 || 0 }}</span>
            </div>
            <div class="buy_box f-sa">
              <div class="buy" @click="navigation('recharge')" v-if="h5">
                <van-button class="buy_btn" type="primary">{{ $t('lang138') }}</van-button>
              </div>
              <div class="buy" @click="navigation('sendChaBao')">
                <van-button class="buy_btn" type="primary">{{ $t('lang278') }}</van-button>
              </div>
              <!-- <div class="buy" @click="navigation('withdraw')">
                <van-button class="buy_btn" type="primary">{{ $t('lang113') }}</van-button>
              </div> -->
              <div class="buy" @click="navigation('')">
                <van-button class="buy_btn" type="primary">{{ $t('lang490') }}</van-button>
              </div>
            </div>
          </div>
          <div class="total_box" v-else-if="coin_type == 'teac'">
            <div>
              <span class="text">{{ $t('lang80') }}(TeaC)</span>
            </div>
            <div class="total">
              <span>{{ Math.floor(teac * 100) / 100 || 0 }}</span>
            </div>
            <div class="buy_box f-sb">
              <div class="buy" @click="navigation('C2CList')">
                <van-button class="buy_btn" type="primary">C2C</van-button>
              </div>
              <div class="buy" @click="navigation('')">
                <van-button class="buy_btn" type="primary">{{ $t('lang490') }}</van-button>
              </div>
              <div class="buy" @click="navigation('sendTeac')">
                <van-button class="buy_btn" type="primary">{{ $t('lang278') }}</van-button>
              </div>
              <div class="buy" @click="navigation('exList')">
                <van-button class="buy_btn" type="primary">{{ $t('lang337') }}</van-button>
              </div>
            </div>
          </div>
          <div class="total_box" v-else-if="coin_type == 'frozen'">
            <div>
              <span class="text">{{ $t('lang80') }}({{ $t('lang339') }})</span>
            </div>
            <div class="total">
              <span>{{ Math.floor(frozen * 100) / 100 || 0 }}</span>
            </div>
            <div class="buy_box f-sa">
              <div class="buy" @click="navigation('')">
                <van-button class="buy_btn" type="primary">{{ $t('lang138') }}</van-button>
              </div>
              <div class="buy" @click="navigation('frozenTransfer')">
                <van-button class="buy_btn" type="primary">{{ $t('lang278') }}</van-button>
              </div>
            </div>
          </div>
          <div class="total_box" v-else-if="coin_type == 'teac_angel'">
            <div>
              <span class="text">{{ $t('lang80') }}({{ $t('lang485') }})</span>
            </div>
            <div class="total">
              <span>{{ Math.floor(teac_angel * 100) / 100 || 0 }}</span>
            </div>
            <div class="buy_box f-sa">
              <div class="buy" @click="navigation('')">
                <van-button class="buy_btn" type="primary">{{ $t('lang490') }}</van-button>
              </div>
              <div class="buy" @click="navigation('sendTeacAngel')">
                <van-button class="buy_btn" type="primary">{{ $t('lang278') }}</van-button>
              </div>
            </div>
          </div>
          <div class="total_box" v-else-if="coin_type == 'teac_ecology'">
            <div>
              <span class="text">{{ $t('lang80') }}({{ $t('lang497') }})</span>
            </div>
            <div class="total">
              <span>{{ Math.floor(teac_ecology * 100) / 100 || 0 }}</span>
            </div>
            <div class="buy_box f-sa">
              <div class="buy" @click="navigation('')">
                <van-button class="buy_btn" type="primary">{{ $t('lang490') }}</van-button>
              </div>
              <div class="buy" @click="navigation('sendTeacEcology')">
                <van-button class="buy_btn" type="primary">{{ $t('lang278') }}</van-button>
              </div>
            </div>
          </div>
        </div>

        <div class="bare" v-if="total <= 0">
          <span>{{ $t('lang60') }}</span>
        </div>
        <div v-else class="container">
          <!-- <div class="navbar">
            <span
              v-for="(item, index) in navList"
              :key="index"
              @click="changeNav(item, index)"
              :style="{ color: navIndex == index ? '#000' : '', 'border-bottom': navIndex == index ? '1px solid #000' : '' }"
              >{{ item.key }}</span
            >
          </div> -->
          <div class="list">
            <div v-for="(item, index) in list" :key="index" class="li">
              <div class="box">
                <div class="box_item">
                  <div class="f-c">
                    <span class="num">{{ dateFormatFn(item.create_time) }}</span>
                    <span class="amount">
                      {{ item.change_amount >= 0 ? '+' + Number(item.change_amount) : Number(item.change_amount) }}
                      <span class="ssm" v-if="coin_type == 'token'">
                        <svg width="14" height="26" viewBox="30 -16 50 96" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                            fill="none"
                            stroke="#29b286"
                            stroke-width="6"
                            stroke-linecap="round"
                          />
                          <line x1="52" y1="29" x2="52" y2="73" stroke="#29b286" stroke-width="5.2" stroke-linecap="round" />
                          <line x1="63" y1="29" x2="63" y2="73" stroke="#29b286" stroke-width="5.2" stroke-linecap="round" />
                        </svg>
                      </span>
                      <span class="ssm" v-else-if="coin_type == 'teac'">TeaC</span>
                      <span class="ssm" v-else-if="coin_type == 'frozen'">{{ $t('lang339') }}</span>
                      <span class="ssm" v-else-if="coin_type == 'teac_angel'">{{ $t('lang485') }}</span>
                      <span class="ssm" v-else-if="coin_type == 'teac_ecology'">{{ $t('lang497') }}</span>
                    </span>
                  </div>
                  <div class="f-c" v-if="coin_type == 'token'">
                    <span class="key">{{ statusList[item.action] }}</span>
                    <span class="key" v-if="item.action == 10 && item.address">
                      {{ $t('lang295') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                    <span class="key" v-if="item.action == 11 && item.address">
                      {{ $t('lang294') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                  </div>
                  <div class="f-c" v-else-if="coin_type == 'teac'">
                    <span class="key">{{ statusList[item.action] }}</span>
                    <span class="key" v-if="item.action == 9 && item.address">
                      {{ $t('lang295') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                    <span class="key" v-if="item.action == 10 && item.address">
                      {{ $t('lang294') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                  </div>
                  <div class="f-c" v-else-if="coin_type == 'frozen'">
                    <span class="key">{{ statusList[item.action] }}</span>
                    <span class="key" v-if="item.action == 3 && item.address">
                      {{ $t('lang295') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                    <span class="key" v-if="item.action == 4 && item.address">
                      {{ $t('lang294') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                  </div>
                  <div class="f-c" v-else-if="coin_type == 'teac_angel'">
                    <span class="key">{{ statusList[item.action] }}</span>
                    <!-- <span class="key" v-if="item.action == 3 && item.address">
                      {{ $t('lang295') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                    <span class="key" v-if="item.action == 4 && item.address">
                      {{ $t('lang294') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span> -->
                  </div>
                  <div class="f-c" v-else-if="coin_type == 'teac_ecology'">
                    <span class="key">{{ statusList[item.action] }}</span>
                    <!-- <span class="key" v-if="item.action == 3 && item.address">
                      {{ $t('lang295') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span>
                    <span class="key" v-if="item.action == 4 && item.address">
                      {{ $t('lang294') + (item.address.substring(0, 5) + '****' + item.address.substring(item.address.length - 5, item.address.length)) }}
                    </span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
export default {
  data() {
    return {
      page: 1,
      loading: false,
      finished: false,
      total: 1,
      nickname: '',
      list: [],
      navIndex: 0,
      navList: [
        // {
        //   key: this.$t('lang115'),
        //   value: 0,
        // },
        {
          key: this.$t('lang114'),
          value: 1,
        },
      ],
      nft_list: [],
      statusList: [],
      balance: 0, //茶宝资产
      teac: 0, // teac资产
      frozen: 0, // 标记茶宝资产
      teac_angel: 0, // teac天使资产
      teac_ecology: 0, // teac生态资产
      coin_type: '',
      h5: 1, //是否是h5端 0否 1是
    };
  },
  mounted() {
    this.coin_type = this.$route.query.coin_type;
    // this.actionGet();
    this.assets();
    this.coinList();
    if(localStorage.getItem('website')){
      this.h5 = 0
    }
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    navigation(name) {
      if (name != '') {
        this.$router.push({ name });
      } else {
        this.$toast(this.$t('lang2'));
      }
    },
    changeNav(item, index) {
      this.navIndex = index;
    },
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 滚动距离
      const scrollHeight = container.scrollHeight; // 内容总高度
      const clientHeight = container.clientHeight; // 可视区域高度
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.page != -1) {
          this.page++; // 页数加 1
          this.coinList(); // 触发加载更多
        }
      }
    },
    assets() {
      homeApi.assets({}).then(res => {
        if (res.code == 200) {
          let data = res.data.coin_list;
          this.balance = data.filter(i => i.coin_key == 'token')[0].amount;
          this.teac = data.filter(i => i.coin_key == 'teac')[0].amount;
          this.frozen = data.filter(i => i.coin_key == 'frozen')[0].amount;
          this.teac_angel = data.filter(i => i.coin_key == 'teac_angel')[0].amount;
          this.teac_ecology = data.filter(i => i.coin_key == 'teac_ecology')[0].amount;
        } else {
        }
      });
    },
    coinList() {
      let params = {
        page: this.page,
        query: {
          coin_type: this.coin_type,
          action: -1,
        },
      };
      homeApi.coinList(params).then(res => {
        if (res.code == 200) {
          this.statusList = res.data.statusList;
          if (this.list.length >= res.data.data.total) {
            this.page = -1; // 重置为 -1，表示没有更多数据
          } else {
            this.list = [...this.list, ...res.data.data.data];
            if (this.list.length >= res.data.data.total) {
              this.page = -1; // 重置为 -1，表示没有更多数据
            }
          }
        } else {
        }
      });
    },
    // actionGet() {
    //   homeApi.assets().then(res => {
    //     if (res.code == 200) {
    //       this.assets = res.data.assets;
    //       this.coinList = res.data.coin_list;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-c {
  display: flex;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.f {
  display: flex;
  align-items: center;
}
.assets {
  height: 100vh;
  overflow: auto;
  padding: 50px 0 0;
  // background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .navbar {
    position: relative;
    border-radius: 14px;
    color: #000;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    span {
      color: #aaaaaa;
      width: 50%;
      margin: 0 40px;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid #ffffff;
    }
  }
  .bg {
    padding: 14px 14px 8px;
    background-color: #fff;

    .total_box {
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      // position: relative;
      font-size: 12px;
      color: #fff;
      height: 150px;
      // border-radius: 16px;
      padding: 20px 20px 40px;
      box-sizing: border-box;
      border-radius: 10px;
      background: linear-gradient(to right, #1bb986, #23d4b7);

      .total {
        font-size: 28px;
        text-align: center;
        padding-top: 10px;
      }
      .text {
        color: rgba(#fff, 0.8);
      }
      .buy_box {
        position: absolute;
        bottom: 14px;
        width: 100%;
        padding: 0 14px;
      }
      .buy {
        &_btn {
          color: #29b286;
          height: 30px;
          max-width: 80px;
          line-height: 30px;
          font-size: 14px;
          background-color: #ffffff;
          border: none;
          padding: 0 16px;
          white-space: nowrap;
          border-radius: 30px;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
        }
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }

  .container {
    position: relative;
    margin: 14px 14px 0;
    border-radius: 14px;
    background-color: #fff;
  }
  .list {
    border-radius: 20px;
    padding: 0 8px;
    margin-top: 16px;
    margin: 16px 6px;
    .li {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 14px 0;

      .box {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_item {
          width: 100%;
          display: flex;
          flex-direction: column;
          .key {
            color: #aaa;
            font-size: 12px;
          }
          .num {
            font-size: 12px;
            color: #000;
            padding-bottom: 16px;
          }
          .amount {
            color: #29b286;
            font-size: 18px;
          }

          .ssm {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>